export const PLAY_MARKET_APP = 'https://play.google.com/store/apps/details?id=com.marathonhealth.app';
export const APP_STORE_APP = 'https://apps.apple.com/us/app/marathon-health/id1569446504';
